var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MouseIcon } from '@patternfly/react-icons';
import { Label } from '@patternfly/react-core';
import { createUseStyles } from 'react-jss';
import { css } from '@patternfly/react-styles';
const symbols = {
    'shift': '⇧',
    'opt': '⌥',
    'cmd': '⌘',
    'enter': '↵',
    'ctrl': '^',
    'caps lock': '⇪',
    'tab': '↹',
    'win': '⊞',
    'backspace': '⌫'
};
const useStyles = createUseStyles({
    shortcut: {
        marginRight: 'var(--pf-t--global--spacer--400)'
    }
});
const Shortcut = (_a) => {
    var { keys = [], description = null, showSymbols = true, hover, click, drag, rightClick, dragAndDrop, className, ouiaId = 'Shortcut' } = _a, props = __rest(_a, ["keys", "description", "showSymbols", "hover", "click", "drag", "rightClick", "dragAndDrop", "className", "ouiaId"]);
    const classes = useStyles();
    const badges = [
        ...(hover ? [
            _jsxs(Label, { variant: "outline", "data-test-id": "hover", children: [_jsx(MouseIcon, {}), " Hover"] }, "hover")
        ] : []),
        ...keys.map((key) => {
            const trimmedKey = key.trim().toLowerCase();
            return (_jsxs(Label, { variant: "outline", "data-test-id": `${key}-key`, children: [showSymbols && symbols[trimmedKey] ? `${symbols[trimmedKey]} ` : '', key.length === 1 ? key.toUpperCase() : key[0].toUpperCase() + key.slice(1).toLowerCase()] }, key));
        }),
        ...(click ? [
            _jsxs(Label, { variant: "outline", "data-test-id": "click", children: [_jsx(MouseIcon, {}), " Click"] }, "click")
        ] : []),
        ...(rightClick ? [
            _jsxs(Label, { variant: "outline", "data-test-id": "right-click", children: [_jsx(MouseIcon, {}), " Right click"] }, "right-click")
        ] : []),
        ...(drag ? [
            _jsxs(Label, { variant: "outline", "data-test-id": "drag", children: [_jsx(MouseIcon, {}), " Drag"] }, "drag")
        ] : []),
        ...(dragAndDrop ? [
            _jsxs(Label, { variant: "outline", "data-test-id": "drag-and-drop", children: [_jsx(MouseIcon, {}), " Drag + Drop"] }, "drag-and-drop")
        ] : [])
    ];
    return (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: css({ [classes.shortcut]: description, className }), "data-ouia-component-id": ouiaId }, props, { children: badges.length > 0 && badges.reduce((prev, curr, idx) => (_jsx("span", { children: [prev, ' + ', curr] }, idx))) })), description] }));
};
export default Shortcut;
